import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { UIModule } from '@library/ui/ui.module';
import { EditUserTimezoneModule } from '@library/ui/views/edit-user-timezone/edit-user-timezone.module';
import { PipesModule } from '@library/utils/pipes/pipes.module';
import { HomeViewComponent } from './home-view.component';
import { LocationViewComponent } from './location-view/location-view.component';
import { TimezoneViewComponent } from './timezone-view/timezone-view.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: '',
        component: HomeViewComponent,
      },
      {
        path: 'location',
        component: LocationViewComponent,
      },
      {
        path: 'timezone',
        component: TimezoneViewComponent,
      },
    ],
  },
];

@NgModule({
  declarations: [
    HomeViewComponent,
    TimezoneViewComponent,
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    PipesModule,
    UIModule,
    EditUserTimezoneModule,
    LocationViewComponent,
  ],
})
export class HomeViewModule {}
